import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { mobileCSS } from '@measures/responsive'

interface NumberCellProps {
  columnType: string
  title?: string
  children?: ReactNode
}

type StyledNumberCellProps = Pick<NumberCellProps, 'columnType'>

const StyledNumberCell = styled.div<StyledNumberCellProps>`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        grey: { grey_100 },
        sport: { sport_55 },
      },
    },
    columnType,
  }) => {
    return css`
      display: grid;
      align-items: center;
      justify-content: ${columnType === 'rank' ? 'left' : 'right'};
      width: 100%;
      height: 100%;
      font-family: ${sourceSansPro};
      font-size: 17px;
      line-height: 1.2;
      font-weight: ${columnType === 'rank' || columnType === 'points'
        ? 'bold'
        : 'normal'};
      color: ${columnType === 'points' ? sport_55 : grey_100};
      letter-spacing: 0.01em;
      padding-left: ${columnType === 'rank' ? '10px' : 0};
      box-sizing: border-box;

      ${mobileCSS(css`
        font-size: 14px;
      `)}
    `
  }}
`

const NumberCell: FunctionComponent<NumberCellProps> = ({
  title,
  columnType,
  children,
}) => {
  return (
    <StyledNumberCell
      {...(columnType === 'rank' && title ? { title } : {})}
      columnType={columnType}>
      {children}
    </StyledNumberCell>
  )
}

export default NumberCell
